import { SessionsAPI } from '../api/SessionAPI';

export const SessionRepository = {
    closeSession: (contextData, requestData) => SessionsAPI.close(contextData, requestData)
};